<div class="privilege">
    <ng-container *ngFor="let menuItem of privilegeLinks;">
        <ng-container *ngIf="menuItem.isActive">
            <ul>
                <span class="privilege-heading">{{menuItem.menuLabel}}</span>
                <span class="label">{{menuItem.customerAssistanceToolsHeading}}
                    <ng-container *ngFor="let customerAssistanceTool of menuItem.customerAssistanceTools">
                        <li *ngIf="customerAssistanceTool.hasAccess && !customerAssistanceTool.selfFundedFlag && customerAssistanceTool.subMenuLabel!=='None'">{{customerAssistanceTool.subMenuLabel}}</li>
                        <span class="subHeading" *ngIf="customerAssistanceTool.hasAccess && customerAssistanceTool.selfFundedFlag && customerAssistanceTool.subMenuLabel!=='None'"><br>{{customerAssistanceTool.subMenuLabel}}</span>
                        <ul class="indentation" *ngIf="(customerAssistanceTool.subPrivilege?.length)  && customerAssistanceTool.hasAccess && customerAssistanceTool.subMenuLabel!=='None'">
                            <ng-container *ngFor="let subprivilege of customerAssistanceTool.subPrivilege">
                                <li *ngIf="subprivilege.hasAccess"><span class="subPrivilege">{{subprivilege.subMenuLabel}}</span></li>
                            </ng-container>
                        </ul>
                        <span *ngIf="!customerAssistanceTool.hasAccess && customerAssistanceTool.subMenuLabel==='None'"
                            class="none-section">None</span>
                    </ng-container>
                </span>
            </ul>
            <ul>
                <span class="label">{{menuItem.adminToolsHeading}}
                    <ng-container *ngFor="let adminTool of menuItem.adminTools">
                        <li *ngIf="adminTool.hasAccess && adminTool.subMenuLabel!=='None'">{{adminTool.subMenuLabel}}</li>
                        <ul class="indentation" *ngIf="adminTool.subPrivilege?.length">
                            <ng-container *ngFor="let subprivilege of adminTool.subPrivilege">
                                <li *ngIf="subprivilege.hasAccess"><span class="subPrivilege">{{subprivilege.subMenuLabel}}</span></li>
                            </ng-container>
                        </ul> 
                        <span *ngIf="!adminTool.hasAccess && adminTool.subMenuLabel==='None' && adminTool.subMenuId!=='noneProspect'"
                             class="none-section">None</span>
                        <span *ngIf="adminTool.hasAccess && adminTool.subMenuLabel==='None'&& adminTool.subMenuId==='noneProspect'"
                             class="none-section">None</span>
                    </ng-container>
                </span>
            </ul>
        </ng-container>
    </ng-container>
</div>